import React, { createContext, useContext, useState } from 'react';

const CommunityModalContext = createContext();

export function CommunityModalProvider({ children }) {
  const [showModal, setShowModal] = useState(false);
  const [activeTab, setActiveTab] = useState('discussions');
  const [activeDiscussionTab, setActiveDiscussionTab] = useState('activity');
  const [activeInvitationTab, setActiveInvitationTab] = useState('orgInvites');
  const [messagingTargetUserId, setMessagingTargetUserId] = useState(null);
  const [messagingExistingConversationId, setMessagingExistingConversationId] = useState(null);

  console.log('CommunityModalProvider: Rendering with state:', {
    showModal,
    activeTab,
    activeDiscussionTab,
    messagingTargetUserId,
    messagingExistingConversationId
  });

  const openModal = (options = {}) => {
    const {
      tab = 'discussions',
      discussionTab = 'activity',
      invitationTab = 'orgInvites',
      targetUserId = null,
      existingConversationId = null
    } = options;

    console.log('CommunityModalContext: openModal called with options:', options);
    console.log('CommunityModalContext: Setting showModal to true');

    setActiveTab(tab);
    setActiveDiscussionTab(discussionTab);
    setActiveInvitationTab(invitationTab);
    setMessagingTargetUserId(targetUserId);
    setMessagingExistingConversationId(existingConversationId);
    setShowModal(true);
    
    console.log('CommunityModalContext: Modal state updated');
  };

  const openMessaging = (targetUserId = null, existingConversationId = null) => {
    console.log('CommunityModalContext: openMessaging called');
    console.log('CommunityModalContext: targetUserId =', targetUserId);
    console.log('CommunityModalContext: existingConversationId =', existingConversationId);
    
    openModal({
      tab: 'discussions',
      discussionTab: 'messages',
      invitationTab: 'orgInvites',
      targetUserId,
      existingConversationId
    });
  };

  const closeModal = () => {
    setShowModal(false);
    setMessagingTargetUserId(null);
    setMessagingExistingConversationId(null);
  };

  const resetMessagingParams = () => {
    setMessagingTargetUserId(null);
    setMessagingExistingConversationId(null);
  };

  return (
    <CommunityModalContext.Provider value={{
      showModal,
      activeTab,
      activeDiscussionTab,
      activeInvitationTab,
      messagingTargetUserId,
      messagingExistingConversationId,
      setShowModal,
      openModal,
      openMessaging,
      closeModal,
      setActiveTab,
      setActiveDiscussionTab,
      setActiveInvitationTab,
      resetMessagingParams
    }}>
      {children}
    </CommunityModalContext.Provider>
  );
}

export const useCommunityModal = () => {
  const context = useContext(CommunityModalContext);
  if (!context) {
    throw new Error('useCommunityModal must be used within a CommunityModalProvider');
  }
  return context;
};
